<template>
  <!--srcviewscompanylistcompanyvuehtmlStart-->
  <div
    v-loading.fullscreen.lock="NewsLoading"
    element-loading-background="rgba(0, 0, 0, 0.6)"
    element-loading-custom-class="my-area"
    element-loading-text="Scanning"
  >
    <div class="u7edc6">
      <div id="gd2da8" class="uVNPU6M">
        <tools
          id="g9a4e3"
          class="u35ff0"
          style="width: 100%"
          :config="$store.state.app.toolsConfig"
          @clickMenu="clickMenu"
          ref="tools"
        >
        </tools>
      </div>
    </div>

    <div id="defaultId1" class="uedbd2" style="display: flex">
      <div
        class="risk_menu_left"
        :class="
          token && this.Saved == '' && !this.Compare && iconactive2 == 'table'
            ? ''
            : 'vague'
        "
        style="height: 100%"
      >
        <div
          class="left_menu"
          :class="$store.state.app.isMenu ? '' : 'hidemenu'"
        >
          <el-collapse
            v-model="openMenu"
            @change="zhankai()"
            ref="collapseItem"
          >
            <el-collapse-item title="Legal Risk" name="3">
              <template slot="title">
                <div class="collapsetitel">
                  Legal Risk<span class="Clear_all" @click="clearAllTags"
                    ><i
                      class="iconfont icon-qingchu"
                      style="color: #ff6a6a; margin-right: 5px"
                    ></i
                    >Clear All</span
                  >
                </div>
              </template>
              <div class="cas_panel cas_loc">
                <el-select
                  clearable
                  v-model="LegalRisk"
                  filterable
                  class="search-select-con"
                  :popper-append-to-body="true"
                  popper-class="new-search-select"
                  placeholder="Select Legal Risk"
                  @change="(val) => onChangeParams(val, 'LegalRisk')"
                >
                  <el-option
                    v-for="(item, index) in UpdateDateList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >
                    <div class="flex-between-center">
                      <span class="select-name">{{ item.label }}</span>
                    </div>
                  </el-option>
                </el-select>
              </div>
            </el-collapse-item>
            <el-collapse-item title="Organizational Risk" name="4">
              <template slot="title">
                <div class="collapsetitel">Organizational Risk</div>
                <!-- <i class="header-icon el-icon-lock hedr-icon-ydong" v-if="!powerResult?.list[1]?.power"></i> -->
              </template>
              <div class="cas_panel cas_loc">
                <el-select
                  clearable
                  v-model="OrganizationalRisk"
                  filterable
                  class="search-select-con"
                  :popper-append-to-body="true"
                  popper-class="new-search-select"
                  placeholder="Select Organizational Risk"
                  @change="(val) => onChangeParams(val, 'OrganizationalRisk')"
                >
                  <el-option
                    v-for="(item, index) in UpdateDateList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >
                    <div class="flex-between-center">
                      <span class="select-name">{{ item.label }}</span>
                    </div>
                  </el-option>
                </el-select>
              </div>
            </el-collapse-item>
            <el-collapse-item title="Operational Risk" name="5">
              <template slot="title">
                <div class="collapsetitel">Operational Risk</div>
                <!-- <i class="header-icon el-icon-lock hedr-icon-ydong" v-if="!powerResult?.list[1]?.power"></i> -->
              </template>
              <div class="cas_panel cas_loc">
                <el-select
                  clearable
                  v-model="OperationalRisk"
                  filterable
                  class="search-select-con"
                  :popper-append-to-body="true"
                  popper-class="new-search-select"
                  placeholder="Select Operational Risk"
                  @change="(val) => onChangeParams(val, 'OperationalRisk')"
                >
                  <el-option
                    v-for="(item, index) in UpdateDateList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >
                    <div class="flex-between-center">
                      <span class="select-name">{{ item.label }}</span>
                    </div>
                  </el-option>
                </el-select>
              </div>
            </el-collapse-item>
            <el-collapse-item title="Financial Risk" name="6">
              <template slot="title">
                <div class="collapsetitel">Financial Risk</div>
                <!-- <i class="header-icon el-icon-lock hedr-icon-ydong" v-if="!powerResult?.list[1]?.power"></i> -->
              </template>
              <div class="cas_panel cas_loc">
                <el-select
                  clearable
                  v-model="FinancialRisk"
                  filterable
                  class="search-select-con"
                  :popper-append-to-body="true"
                  popper-class="new-search-select"
                  placeholder="Select Financial Risk"
                  @change="(val) => onChangeParams(val, 'FinancialRisk')"
                >
                  <el-option
                    v-for="(item, index) in UpdateDateList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >
                    <div class="flex-between-center">
                      <span class="select-name">{{ item.label }}</span>
                    </div>
                  </el-option>
                </el-select>
              </div>
            </el-collapse-item>
            <el-collapse-item title="Credit Risk" name="7">
              <template slot="title">
                <div class="collapsetitel">Credit Risk</div>
                <!-- <i class="header-icon el-icon-lock hedr-icon-ydong" v-if="!powerResult?.list[1]?.power"></i> -->
              </template>
              <div class="cas_panel cas_loc">
                <el-select
                  clearable
                  v-model="CreditRisk"
                  filterable
                  class="search-select-con"
                  :popper-append-to-body="true"
                  popper-class="new-search-select"
                  placeholder="Select Credit Risk"
                  @change="(val) => onChangeParams(val, 'CreditRisk')"
                >
                  <el-option
                    v-for="(item, index) in UpdateDateList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >
                    <div class="flex-between-center">
                      <span class="select-name">{{ item.label }}</span>
                    </div>
                  </el-option>
                </el-select>
              </div>
            </el-collapse-item>
            <el-collapse-item title="Compliance " name="8">
              <template slot="title">
                <div class="collapsetitel">Compliance</div>
                <!-- <i class="header-icon el-icon-lock hedr-icon-ydong" v-if="!powerResult?.list[1]?.power"></i> -->
              </template>
              <div class="cas_panel cas_loc">
                <el-select
                  clearable
                  v-model="ComplianceRisk"
                  filterable
                  class="search-select-con"
                  :popper-append-to-body="true"
                  popper-class="new-search-select"
                  placeholder="Select Compliance "
                  @change="(val) => onChangeParams(val, 'ComplianceRisk')"
                >
                  <el-option
                    v-for="(item, index) in UpdateDateList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >
                    <div class="flex-between-center">
                      <span class="select-name">{{ item.label }}</span>
                    </div>
                  </el-option>
                </el-select>
              </div>
            </el-collapse-item>
            <el-collapse-item title="Sustainability " name="9">
              <template slot="title">
                <div class="collapsetitel">Sustainability</div>
                <!-- <i class="header-icon el-icon-lock hedr-icon-ydong" v-if="!powerResult?.list[1]?.power"></i> -->
              </template>
              <div class="cas_panel cas_loc">
                <el-select
                  clearable
                  v-model="SustainabilityRisk"
                  filterable
                  class="search-select-con"
                  :popper-append-to-body="true"
                  popper-class="new-search-select"
                  placeholder="Select Sustainability "
                  @change="(val) => onChangeParams(val, 'SustainabilityRisk')"
                >
                  <el-option
                    v-for="(item, index) in UpdateDateList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >
                    <div class="flex-between-center">
                      <span class="select-name">{{ item.label }}</span>
                    </div>
                  </el-option>
                </el-select>
              </div>
            </el-collapse-item>
            <el-collapse-item title="Industry Risk" name="10">
              <template slot="title">
                <div class="collapsetitel">Industry Risk</div>
                <!-- <i class="header-icon el-icon-lock hedr-icon-ydong" v-if="!powerResult?.list[1]?.power"></i> -->
              </template>
              <div class="cas_panel cas_loc">
                <el-select
                  clearable
                  v-model="IndustryRisk"
                  filterable
                  class="search-select-con"
                  :popper-append-to-body="true"
                  popper-class="new-search-select"
                  placeholder="Select Industry Risk"
                  @change="(val) => onChangeParams(val, 'IndustryRisk')"
                >
                  <el-option
                    v-for="(item, index) in UpdateDateList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >
                    <div class="flex-between-center">
                      <span class="select-name">{{ item.label }}</span>
                    </div>
                  </el-option>
                </el-select>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <div
        id="cc5f49"
        :class="
          $store.state.app.isMenu
            ? 'scrollbar scrollbar_right'
            : ' scrollbar scrollbar_right udb507two'
        "
      >
        <div class="right_cont_box computer_right_cont_box company_box">
          <div class="table-index" v-show="!Compare">
            <div class="flex_center margin-bottom20">
              <div class="search_rsult_txttwo line_2">
                <span v-if="!Remove" class="font24 font_bold font1A2332">
                  Risk Scan</span
                >
              </div>
              <div class="flex_center_bettwen">
                <div class="flex_center_bettwen Risk-Scanning-right">
                  <span
                    class="font20 font1290C9 textdecoration"
                    style="cursor: pointer"
                    @click="reportDialog = true"
                    >Reselect data</span
                  >
                  <span
                    class="font20 textdecoration"
                    :class="
                      updateDowinList.length > 0
                        ? 'font1290C9 cuspoint '
                        : 'font999999 cuspointno'
                    "
                    @click="DownloadRisksan()"
                    >Update Data</span
                  >
                  <span class="font20 font999999 textdecoration cuspointno"
                    >Download Result</span
                  >
                  <span
                    class="font20 textdecoration"
                    :class="
                      compareListParent.length == 1 &&
                      this.iconactive2 == 'table'
                        ? 'font1290C9 cuspoint '
                        : 'font999999 cuspointno'
                    "
                    @click="openUrl('/index/list/risk')"
                    >Search Leads</span
                  >
                </div>
                <div>
                  <span class="ViewMore contclass">
                    <div
                      :class="
                        iconactive2 == 'table' ? 'svgbg svgclass' : 'svgclass'
                      "
                    >
                      <svg
                        t="1718592308727"
                        v-if="iconactive2 == 'table'"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="8137"
                        width="2.2857rem"
                        height="2.2857rem"
                      >
                        <path
                          d="M928 938.666667H96a53.393333 53.393333 0 0 1-53.333333-53.333334V181.333333a53.393333 53.393333 0 0 1 53.333333-53.333333h832a53.393333 53.393333 0 0 1 53.333333 53.333333v704a53.393333 53.393333 0 0 1-53.333333 53.333334z m-245.333333-42.666667h245.333333a10.666667 10.666667 0 0 0 10.666667-10.666667v-202.666666h-256z m-298.666667 0h256v-213.333333H384z m-298.666667-213.333333v202.666666a10.666667 10.666667 0 0 0 10.666667 10.666667h245.333333v-213.333333z m597.333334-42.666667h256V426.666667h-256z m-298.666667 0h256V426.666667H384z m-298.666667 0h256V426.666667H85.333333z m853.333334-256V181.333333a10.666667 10.666667 0 0 0-10.666667-10.666666H96a10.666667 10.666667 0 0 0-10.666667 10.666666v202.666667z"
                          fill="#1290C9"
                          p-id="8138"
                        ></path>
                      </svg>

                      <svg
                        t="1718592110652"
                        v-else
                        @click="clickIcon('table')"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="7626"
                        width="32"
                        height="32"
                      >
                        <path
                          d="M928 938.666667H96a53.393333 53.393333 0 0 1-53.333333-53.333334V181.333333a53.393333 53.393333 0 0 1 53.333333-53.333333h832a53.393333 53.393333 0 0 1 53.333333 53.333333v704a53.393333 53.393333 0 0 1-53.333333 53.333334z m-245.333333-42.666667h245.333333a10.666667 10.666667 0 0 0 10.666667-10.666667v-202.666666h-256z m-298.666667 0h256v-213.333333H384z m-298.666667-213.333333v202.666666a10.666667 10.666667 0 0 0 10.666667 10.666667h245.333333v-213.333333z m597.333334-42.666667h256V426.666667h-256z m-298.666667 0h256V426.666667H384z m-298.666667 0h256V426.666667H85.333333z m853.333334-256V181.333333a10.666667 10.666667 0 0 0-10.666667-10.666666H96a10.666667 10.666667 0 0 0-10.666667 10.666666v202.666667z"
                          fill="#5C5C66"
                          p-id="7627"
                        ></path>
                      </svg>
                    </div>
                    <div
                      :class="
                        iconactive2 == 'computer'
                          ? 'svgbg svgclass'
                          : 'svgclass'
                      "
                    >
                      <svg
                        t="1718592168330"
                        v-if="iconactive2 == 'computer'"
                        class="icon"
                        viewBox="0 0 1214 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="7861"
                        width="2.2857rem"
                        height="2.2857rem"
                      >
                        <path
                          d="M94.734629 819.2c-52.0192 0-94.354286-40.872229-94.354286-91.077486V341.284571c0-13.312 11.190857-24.107886 24.9856-24.107885 13.780114 0 22.908343 10.795886 22.908343 24.107885v386.823315c0 23.639771 21.986743 44.675657 46.460343 44.675657h1018.953142c24.488229 0 47.030857-21.035886 47.030858-44.675657V93.037714c0-23.6544-22.528-43.695543-47.030858-43.695543H94.734629C70.261029 49.3568 48.274286 69.397943 48.274286 93.037714v107.373715c0 13.297371-9.128229 24.093257-22.908343 24.093257-13.794743 0-25.000229-10.795886-25.000229-24.107886V93.037714C0.365714 42.832457 42.715429 1.989486 94.734629 1.989486h1018.953142c52.0192 0 94.339657 40.842971 94.339658 91.077485v635.070172c0 50.205257-42.320457 91.077486-94.339658 91.077486H94.734629z"
                          fill="#1290C9"
                          p-id="7862"
                        ></path>
                        <path
                          d="M704.2048 965.485714H855.771429c12.112457 0 21.694171 11.264 21.694171 23.376457 0 12.112457-9.581714 23.6544-21.694171 23.6544h-482.742858c-12.112457 0-22.191543-11.541943-22.191542-23.6544 0-12.127086 10.079086-23.376457 22.191542-23.376457h151.581258V819.2H570.514286v146.285714h87.771428V819.2h45.919086v146.285714zM177.678629 620.163657h44.426971V461.531429h-44.426971zM296.1408 620.163657h44.412343V389.412571h-44.412343zM429.407086 620.163657h44.412343V317.293714h-44.412343zM236.909714 187.4944c0 15.915886-13.268114 28.847543-29.608228 28.847543-16.384 0-29.622857-12.931657-29.622857-28.847543 0-15.945143 13.253486-28.847543 29.622857-28.847543 16.340114 0 29.608229 12.9024 29.608228 28.847543M325.749029 187.4944c0 15.915886-13.268114 28.847543-29.608229 28.847543s-29.608229-12.931657-29.608229-28.847543c0-15.945143 13.268114-28.847543 29.608229-28.847543s29.608229 12.9024 29.608229 28.847543M714.591086 420.322743h148.728685l112.347429-93.432686c-26.814171-30.939429-68.183771-52.077714-112.347429-52.077714-79.491657 0-146.666057 66.530743-148.728685 145.5104zM820.662857 568.188343l21.869714-113.2544h-126.098285c16.310857 53.642971 51.053714 91.399314 104.228571 113.2544z m174.474972-210.549029l-91.428572 77.297372 91.428572 54.535314C1004.251429 470.381714 1009.371429 446.800457 1009.371429 424.228571c0-23.2448-4.593371-47.074743-14.2336-66.589257zM877.714286 462.760229l-20.289829 110.270171c1.594514 0.043886 3.189029 0.073143 4.783543 0.073143 44.909714 0 87.815314-20.904229 114.644114-52.736L877.714286 462.760229zM863.085714 614.4c-105.033143 0-190.171429-85.138286-190.171428-190.171429s85.138286-190.171429 190.171428-190.171428 190.171429 85.138286 190.171429 190.171428-85.138286 190.171429-190.171429 190.171429z"
                          fill="#1290C9"
                          p-id="7863"
                        ></path>
                      </svg>

                      <svg
                        t="1718592454748"
                        @click="clickIcon('computer')"
                        v-else
                        class="icon"
                        viewBox="0 0 1214 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="8412"
                        width="2.2857rem"
                        height="2.2857rem"
                      >
                        <path
                          d="M94.734629 819.2c-52.0192 0-94.354286-40.872229-94.354286-91.077486V341.284571c0-13.312 11.190857-24.107886 24.9856-24.107885 13.780114 0 22.908343 10.795886 22.908343 24.107885v386.823315c0 23.639771 21.986743 44.675657 46.460343 44.675657h1018.953142c24.488229 0 47.030857-21.035886 47.030858-44.675657V93.037714c0-23.6544-22.528-43.695543-47.030858-43.695543H94.734629C70.261029 49.3568 48.274286 69.397943 48.274286 93.037714v107.373715c0 13.297371-9.128229 24.093257-22.908343 24.093257-13.794743 0-25.000229-10.795886-25.000229-24.107886V93.037714C0.365714 42.832457 42.715429 1.989486 94.734629 1.989486h1018.953142c52.0192 0 94.339657 40.842971 94.339658 91.077485v635.070172c0 50.205257-42.320457 91.077486-94.339658 91.077486H94.734629z"
                          fill="#000000"
                          p-id="8413"
                        ></path>
                        <path
                          d="M704.2048 965.485714H855.771429c12.112457 0 21.694171 11.264 21.694171 23.376457 0 12.112457-9.581714 23.6544-21.694171 23.6544h-482.742858c-12.112457 0-22.191543-11.541943-22.191542-23.6544 0-12.127086 10.079086-23.376457 22.191542-23.376457h151.581258V819.2H570.514286v146.285714h87.771428V819.2h45.919086v146.285714zM177.678629 620.163657h44.426971V461.531429h-44.426971zM296.1408 620.163657h44.412343V389.412571h-44.412343zM429.407086 620.163657h44.412343V317.293714h-44.412343zM236.909714 187.4944c0 15.915886-13.268114 28.847543-29.608228 28.847543-16.384 0-29.622857-12.931657-29.622857-28.847543 0-15.945143 13.253486-28.847543 29.622857-28.847543 16.340114 0 29.608229 12.9024 29.608228 28.847543M325.749029 187.4944c0 15.915886-13.268114 28.847543-29.608229 28.847543s-29.608229-12.931657-29.608229-28.847543c0-15.945143 13.268114-28.847543 29.608229-28.847543s29.608229 12.9024 29.608229 28.847543M714.591086 420.322743h148.728685l112.347429-93.432686c-26.814171-30.939429-68.183771-52.077714-112.347429-52.077714-79.491657 0-146.666057 66.530743-148.728685 145.5104zM820.662857 568.188343l21.869714-113.2544h-126.098285c16.310857 53.642971 51.053714 91.399314 104.228571 113.2544z m174.474972-210.549029l-91.428572 77.297372 91.428572 54.535314C1004.251429 470.381714 1009.371429 446.800457 1009.371429 424.228571c0-23.2448-4.593371-47.074743-14.2336-66.589257zM877.714286 462.760229l-20.289829 110.270171c1.594514 0.043886 3.189029 0.073143 4.783543 0.073143 44.909714 0 87.815314-20.904229 114.644114-52.736L877.714286 462.760229zM863.085714 614.4c-105.033143 0-190.171429-85.138286-190.171428-190.171429s85.138286-190.171429 190.171428-190.171428 190.171429 85.138286 190.171429 190.171428-85.138286 190.171429-190.171429 190.171429z"
                          fill="#000000"
                          p-id="8414"
                        ></path>
                      </svg>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            <!-- <div class="search_rsult_txttwo line_2" v-if="isOpenSlct && !Remove && iconactive2 == 'table'" >
                <el-button v-if="isOpenSlct && !Remove" style="height: 40px !important;min-height: 40px !important;"
                  :class="$store.state.app.collectList.length == 0 || $store.state.app.changeList.length == 0 ? ' btn_export btn_exporthui' : 'btn_export'"
                  :disabled="$store.state.app.collectList.length == 0 || $store.state.app.changeList.length == 0"
                  @click="CollectCheckBook">Confirm</el-button>
                <div v-if="Remove" style="display: flex;align-items: center;cursor: pointer;" class="margin-left20">
                  <svg t="1728612191932" @click="backonlonad()" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="9222" width="24" height="24">
                    <path
                      d="M879.476364 470.341818H244.829091L507.112727 209.454545a41.658182 41.658182 0 0 0-58.88-58.88L114.967273 482.676364a41.890909 41.890909 0 0 0 0 58.88l333.265454 333.032727a41.658182 41.658182 0 0 0 58.88 0 41.890909 41.890909 0 0 0 0-58.88L244.829091 553.658182h634.647273a41.658182 41.658182 0 1 0 0-83.316364z"
                      p-id="9223" fill="#1296db"></path>
                  </svg>
                  <el-button style="height: 40px !important;min-height: 40px !important;"
                    :class="$store.state.app.changeList.length == 0 ? ' btn_export btn_exporthui' : 'btn_exportred btn_export'"
                    :disabled="$store.state.app.changeList.length == 0" @click="CollectDelate">Remove</el-button>
                </div>
              </div> -->

            <div
              class="company_list table_container"
              id="tableBox"
              ref="tableBox"
            >
              <el-table
                v-if="iconactive2 == 'table'"
                class="table_height_30 company_list table_font_size_14 table_contentHeight_40 table_padding_0"
                @selection-change="handleSelectionChange"
                ref="treeTable"
                id="tableNode"
                :data="parentTable"
                height="100%"
                :row-class-name="getRowClass"
                :key="refresh"
                :border="true"
                cell-class-name="company line_1"
                row-key="aaaId"
                :expand-row-keys="expands"
              >
                <el-table-column
                  v-if="isOpenSlct"
                  type="selection"
                  width="45"
                  align="center"
                >
                </el-table-column>

                <el-table-column
                  :label="$t('Profile.CompanyName')"
                  fixed
                  min-width="300"
                  prop="company_name_en"
                  align="left"
                  class-name="company company_link company_link_tooltip_normal"
                  show-overflow-tooltip
                  :resizable="true"
                >
                  <template slot="header" slot-scope="scope">
                    <span
                      class="flex_center_start_box"
                      style="font-family: 'Arial Bold'"
                      >{{ $t("Profile.CompanyName") }}
                    </span>
                  </template>

                  <template slot-scope="scope">
                    <div class="flex_center_start_box" style="flex: none">
                      <div class="flex_center_start_box" style="flex: none">
                        <div
                          class="btn_expand"
                          :class="{ expand_icon: scope.row.isExpand }"
                          @click="onClickExpansion(scope.row)"
                        ></div>

                        <!-- <img @click="gotocountry(scope.row)" :src="scope.row.flag" /> -->
                      </div>

                      <div @click="setid(scope.row)" class="tbl_company">
                        {{ scope.row.companyNameEn }}
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Last Update"
                  width="130"
                  fixed
                  prop="UpdateDate"
                  show-overflow-tooltip
                  :resizable="true"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.updateDate }}</span>
                    <!-- 修改这里 -->
                  </template>
                </el-table-column>

                <el-table-column
                  v-for="(item, index) in selectedColumns"
                  :key="index"
                  :label="item.screenName"
                  :min-width="165"
                  :prop="item.columnName"
                  show-overflow-tooltip
                  :resizable="true"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span
                      :class="'RiskColor' + scope.row[item.columnName]"
                      class="RiskColor"
                    >
                    </span>
                    <!-- 修改这里 -->
                  </template>
                </el-table-column>
                <el-table-column
                  label=""
                  width="80"
                  :resizable="true"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-tooltip
                      class="tbl_opr_tip flex_center"
                      :visible-arrow="false"
                      effect="light"
                      content="Download"
                      placement="top"
                    >
                      <svg
                        @click="DownloadOnlinePdfDetail(scope.row)"
                        id="c1f02f"
                        class="icon"
                        t="1717122025138"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="5156"
                        width="2rem"
                        height="2rem"
                      >
                        <path
                          id="cf91f2"
                          d="M491.52 858.112l-108.544-106.496c-8.192-8.192-20.48-8.192-28.672 0-8.192 8.192-8.192 20.48 0 28.672l139.264 135.168c0 2.048 2.048 6.144 4.096 8.192 4.096 4.096 10.24 6.144 16.384 6.144 6.144 0 12.288-2.048 16.384-6.144 2.048-2.048 4.096-4.096 4.096-8.192l139.264-135.168c8.192-8.192 8.192-20.48 0-28.672-8.192-8.192-20.48-8.192-28.672 0l-110.592 108.544v-368.64c0-12.288-8.192-20.48-20.48-20.48s-20.48 8.192-20.48 20.48v366.592z m-399.36-344.064v-307.2c0-45.056 36.864-81.92 81.92-81.92h675.84c45.056 0 81.92 36.864 81.92 81.92v307.2c0 45.056-36.864 81.92-81.92 81.92h-96.256c-12.288 0-20.48 8.192-20.48 20.48s8.192 20.48 20.48 20.48h96.256c67.584 0 122.88-55.296 122.88-122.88v-307.2c0-67.584-55.296-122.88-122.88-122.88h-675.84c-67.584 0-122.88 55.296-122.88 122.88v307.2c0 67.584 55.296 122.88 122.88 122.88v-40.96h-4.096v40.96h102.4c12.288 0 20.48-8.192 20.48-20.48s-8.192-20.48-20.48-20.48h-98.304c-45.056 0-81.92-36.864-81.92-81.92z m296.96-237.568c-12.288 0-20.48 8.192-20.48 20.48s8.192 20.48 20.48 20.48h245.76c12.288 0 20.48-8.192 20.48-20.48s-8.192-20.48-20.48-20.48h-245.76z"
                          fill="#1290c9"
                          p-id="5157"
                        ></path>
                      </svg>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column type="expand" align="center">
                  <template slot-scope="scope">
                    <div
                      class="tree_table_box flex_center_bettwen"
                      v-loading="ChidLoding"
                      v-if="true"
                      style="flex-wrap: wrap"
                    >
                      <div class="riskScaning-tree">
                        <p
                          class="riskScaning-tree-title font_bold font20"
                          :class="
                            'fontRiskColor' +
                            scope.row.companyLegalRiskSignalCode
                          "
                        >
                          Legal Risk
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666">Company ID</span>
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyLegalRiskVO?.companyId
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666">Company Type</span>
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyLegalRiskVO
                              ?.companyTypeCodeDescEn
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666"
                            >Registration Date</span
                          >
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyLegalRiskVO?.registrationDate
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666"
                            >Registration Status</span
                          >
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyLegalRiskVO
                              ?.registrationStatus
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666">Listed</span>
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyLegalRiskVO?.listed
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666">Legal Status</span>
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyLegalRiskVO?.legalStatus
                          }}</span>
                        </p>
                      </div>
                      <div class="riskScaning-tree">
                        <p
                          class="riskScaning-tree-title font_bold font20"
                          :class="
                            'fontRiskColor' +
                            scope.row.companyOrgStructureRiskSignalCode
                          "
                        >
                          Organizational Risk
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666"
                            >No. of Shareholders</span
                          >
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyOrgStructureRiskVO
                              ?.shareholders
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666"
                            >Shareholding Layers</span
                          >
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyOrgStructureRiskVO
                              ?.shareholdingLayers
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666"
                            >No. of Corporate Shareholders</span
                          >
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyOrgStructureRiskVO
                              ?.corporateShareholders
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666"
                            >No. of Natual Person Shareholders</span
                          >
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyOrgStructureRiskVO
                              ?.individualShareholders
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666"
                            >Related Companies</span
                          >
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyOrgStructureRiskVO
                              ?.relatedCompanies
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666"
                            >Organizational Status</span
                          >
                          <span
                            class="font16 font1A2332 textRight fontRiskColor1"
                            v-if="
                              treeTableObjct?.companyOrgStructureRiskVO
                                ?.organizationalStatus == 1
                            "
                          >
                            {{
                              treeTableObjct?.companyOrgStructureRiskVO
                                ?.organizationalStatusEn
                            }}
                          </span>
                          <span
                            class="font16 font1A2332 textRight fontRiskColor2"
                            v-if="
                              treeTableObjct?.companyOrgStructureRiskVO
                                ?.organizationalStatus == 2
                            "
                          >
                            {{
                              treeTableObjct?.companyOrgStructureRiskVO
                                ?.organizationalStatusEn
                            }}
                          </span>
                          <span
                            class="font16 font1A2332 textRight fontRiskColor3"
                            v-if="
                              treeTableObjct?.companyOrgStructureRiskVO
                                ?.organizationalStatus == 3
                            "
                          >
                            {{
                              treeTableObjct?.companyOrgStructureRiskVO
                                ?.organizationalStatusEn
                            }}
                          </span>
                          <span
                            class="font16 font1A2332 textRight fontRiskColor4"
                            v-if="
                              treeTableObjct?.companyOrgStructureRiskVO
                                ?.organizationalStatus == 4
                            "
                          >
                            {{
                              treeTableObjct?.companyOrgStructureRiskVO
                                ?.organizationalStatusEn
                            }}
                          </span>
                        </p>
                      </div>
                      <div class="riskScaning-tree">
                        <p
                          class="riskScaning-tree-title font_bold font20"
                          :class="
                            'fontRiskColor' +
                            scope.row.companyOperatingRiskSignalCode
                          "
                        >
                          Operational Risk
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666"
                            >Operating Address</span
                          >
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyOperatingRiskVO
                              ?.operatingAddressVefified
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666">Industry Code</span>
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyOperatingRiskVO?.industryCode
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666"
                            >Business Activities</span
                          >
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyOperatingRiskVO
                              ?.businessActivities
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666"
                            >No. of Employees</span
                          >
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyOperatingRiskVO?.employees
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666">Management</span>
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyOperatingRiskVO
                              ?.managementStatus
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666"
                            >Current Operations</span
                          >
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyOperatingRiskVO
                              ?.currentOperationsStatus
                          }}</span>
                        </p>
                      </div>
                      <div class="riskScaning-tree">
                        <p
                          class="riskScaning-tree-title font_bold font20"
                          :class="
                            'fontRiskColor' +
                            scope.row.companyFinancialRiskSignalCode
                          "
                        >
                          Financial Risk
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666">Revenue</span>
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyFinancialRiskVO?.revenue
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666">Assets</span>
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyFinancialRiskVO?.assests
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666">Profit/Loss</span>
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyFinancialRiskVO?.profitOrLoss
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666">Liquidity</span>
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyFinancialRiskVO?.liquidity
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666">Growth</span>
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyFinancialRiskVO?.growth
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666">Performance</span>
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyFinancialRiskVO?.performance
                          }}</span>
                        </p>
                      </div>
                      <div class="riskScaning-tree">
                        <p
                          class="riskScaning-tree-title font_bold font20"
                          :class="
                            'fontRiskColor' +
                            scope.row.companyCreditRiskSignalCode
                          "
                        >
                          Credit Risk
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666">Credit Rating</span>
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyCreditRiskVO?.creditRating
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666">Credit Score</span>
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyCreditRiskVO?.creditScore
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666"
                            >Pausibility of Default (PD)</span
                          >
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyCreditRiskVO?.pd
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666">Solvency Index</span>
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyCreditRiskVO?.solvencyIndex
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666">Debt Collection</span>
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyCreditRiskVO?.debtCollection
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666">Credit Opinion</span>
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyCreditRiskVO?.riskIndex
                          }}</span>
                        </p>
                      </div>
                      <div class="riskScaning-tree">
                        <p
                          class="riskScaning-tree-title font_bold font20"
                          :class="
                            'fontRiskColor' + scope.row.complianceRiskSignalCode
                          "
                        >
                          Compliance
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666"
                            >Company Sanction</span
                          >
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyComplianceRiskVO
                              ?.companySanction
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666"
                            >Product Sanction</span
                          >
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyComplianceRiskVO
                              ?.productSanction
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666">Export Control</span>
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyComplianceRiskVO
                              ?.exportControl
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666"
                            >Anti-Corruption & Anti-Bribery</span
                          >
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyComplianceRiskVO
                              ?.antiCorruptionAndBribery
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666">Litigations</span>
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyComplianceRiskVO?.litigations
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666">Negative News</span>
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyComplianceRiskVO
                              ?.negativeNews
                          }}</span>
                        </p>
                      </div>
                      <div class="riskScaning-tree">
                        <p
                          class="riskScaning-tree-title font_bold font20"
                          :class="
                            'fontRiskColor' +
                            scope.row.companySustainabilityRiskSignalCode
                          "
                        >
                          Sustainability
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666">ESG Score</span>
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companySustainabilityRiskVO
                              ?.ratingESG
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666"
                            >Years in Business</span
                          >
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companySustainabilityRiskVO
                              ?.yearsInBusiness
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666">Competitiveness</span>
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companySustainabilityRiskVO
                              ?.competitiveness
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666">Working Capital</span>
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companySustainabilityRiskVO
                              ?.workingCapital
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666"
                            >Financial Structure</span
                          >
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companySustainabilityRiskVO
                              ?.financialStructure
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666">Growth</span>
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companySustainabilityRiskVO?.growth
                          }}</span>
                        </p>
                      </div>
                      <div class="riskScaning-tree">
                        <p
                          class="riskScaning-tree-title font_bold font20"
                          :class="
                            'fontRiskColor' +
                            scope.row.companyIndustryRiskSignalCode
                          "
                        >
                          Industry Risk
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666"
                            >Industry Outlook</span
                          >
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyIndustryRiskVO
                              ?.industryForecast
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666"
                            >No. of Companies</span
                          >
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyIndustryRiskVO
                              ?.companiesOfIndustry
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666"
                            >Industry Ranking</span
                          >
                          <span class="font16 font1A2332 textRight"
                            ><span
                              v-if="
                                treeTableObjct?.companyIndustryRiskVO
                                  ?.industryPosition != '-'
                              "
                              >Industry Norm</span
                            >
                            {{
                              treeTableObjct?.companyIndustryRiskVO
                                ?.industryPosition
                            }}<span
                              v-if="
                                treeTableObjct?.companyIndustryRiskVO
                                  ?.industryPosition != '-'
                              "
                              >%</span
                            ></span
                          >
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666"
                            >Industry Concentration</span
                          >
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyIndustryRiskVO
                              ?.industryCentralization
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666"
                            >Industry Competitiveness</span
                          >
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyIndustryRiskVO
                              ?.industryCompetition
                          }}</span>
                        </p>
                        <p class="flex_center_bettwen margin-top20">
                          <span class="font16 font666666"
                            >Industry Development</span
                          >
                          <span class="font16 font1A2332 textRight">{{
                            treeTableObjct?.companyIndustryRiskVO
                              ?.industryDevelopment
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label=""
                  width="80"
                  :resizable="true"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-tooltip
                      class="tbl_opr_tip flex_center"
                      :visible-arrow="false"
                      effect="light"
                      content="Diagnostic Report"
                      placement="top"
                    >
                      <svg
                        t="1763011331557"
                        class="icon cuspointno"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="8016"
                        width="2rem"
                        height="2rem"
                      >
                        <path
                          d="M691.743411 332.608328c10.36799 0 20.223981 3.999996 27.391975 10.97599h41.407961c24.863977 1.599999 48.063955 12.703988 64.25594 30.911971 23.199978 26.303975 32.831969 81.695923 23.295978 131.519877l-4.639996 25.599976c-20.223981 110.911896-50.335953 203.615809-184.543827 215.039798v0.703999a21.887979 21.887979 0 0 1-22.239979 21.43998v145.663864c0 33.183969 65.183939 60.095944 101.247905 60.095943h7.743993c36.031966 0 101.247905-26.879975 101.247905-60.095943v-51.839952c-36.575966-10.30399-63.423941-42.84796-63.423941-81.375923 0-46.719956 39.519963-84.799921 88.191918-84.799921 48.543954 0 88.159917 37.983964 88.159917 84.799921-0.096 36.927965-24.799977 68.479936-59.135945 80.063925v53.05595c-0.352 60.767943-89.599916 109.759897-155.039854 109.631897h-7.743993c-65.567939 0-155.039855-49.215954-155.039855-109.631897v-145.823864h-2.239997a22.175979 22.175979 0 0 1-22.623979-21.759979c-138.14387-8.447992-165.407845-103.231903-185.855826-215.263798l-4.639996-25.631976c-9.407991-49.919953-3.103997-105.183901 20.095981-131.519877a93.279913 93.279913 0 0 1 64.12794-30.911971h41.535961c7.263993-7.071993 17.119984-10.97599 27.359975-10.87999 20.799981 0 37.727965 15.583985 37.855964 34.815968-0.128 14.079987-9.055992 26.655975-22.623979 32.03197a39.807963 39.807963 0 0 1-40.703961-6.399994h-41.759961c-9.631991 1.279999-18.431983 6.079994-24.639977 13.279987-12.351988 14.655986-14.719986 57.119946-8.319992 91.199915l4.767995 25.983975c22.975978 126.719881 47.007956 165.983844 132.799876 173.983837 0-11.327989 9.503991-20.479981 21.27998-20.479981h58.687945c11.519989 0 20.799981 8.927992 20.79998 20.031982 82.111923-11.00799 108.991898-49.119954 131.615877-173.407838l4.767995-25.983976c6.527994-34.687967 0.703999-77.375927-12.159988-91.903913a39.103963 39.103963 0 0 0-23.999978-12.703988h-41.791961c-11.19999 9.503991-26.879975 12.031989-40.575961 6.399994a34.911967 34.911967 0 0 1-22.591979-32.03197c0-9.279991 4.031996-18.207983 11.039989-24.607977 7.135993-6.623994 16.799984-10.30399 26.655975-10.175991zM736.735369 0.00064c13.919987 0 25.215976 10.87999 25.215977 24.255977v214.591799c0 13.407987-11.295989 24.287977-25.215977 24.287977-13.919987 0-25.215976-10.87999-25.215976-24.287977V48.416595L298.94378 48.384595v167.231843a24.927977 24.927977 0 0 1-25.215977 24.287977l-159.45585-0.032v621.823417h356.159666c13.919987 0 25.215976 10.87999 25.215976 24.287977 0 13.247988-11.295989 24.127977-25.215976 24.127978H89.055976c-13.919987 0-25.215976-10.87999-25.215976-24.255977V193.760458c0-6.399994 2.623998-12.575988 7.359993-17.151984L247.583828 7.104633A25.727976 25.727976 0 0 1 265.439811 0.00064h471.327558z m134.943874 741.439305c-22.847979 0-41.407961 17.823983-41.407962 39.807963 0 21.983979 18.559983 39.839963 41.407962 39.839962 22.847979 0 41.407961-17.855983 41.407961-39.839962-0.128-21.983979-18.687982-39.839963-41.407961-39.839963zM248.479827 74.56057L127.199941 191.360461h121.311886V74.59257z"
                          fill="#ccc"
                          p-id="8017"
                        ></path>
                      </svg>
                    </el-tooltip>
                  </template>
                </el-table-column>

                <template slot="empty">
                  <div class="flex_center margin-top30">
                    <img
                      src="../../assets/images/noDate.png"
                      style="width: 50%; height: 50%"
                      alt=""
                    />
                  </div>
                </template>
              </el-table>
              <div
                v-if="iconactive2 == 'computer'"
                class="flex_center_bettwen"
                style="flex-wrap: wrap"
              >
                <div class="Risk-Scanning-echarts">
                  <p
                    class="font20 font1A2332 margin-bottom20 margin-top20 font_bold"
                  >
                    Legal Risk
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor1"></span
                      ><span class="font18 font1A2332">Good</span></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.legalRisk?.good
                    }}</span>
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor2"></span
                      ><span class="font18 font1A2332">General</span></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.legalRisk?.general
                    }}</span>
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor3"></span
                      ><span class="font18 font1A2332">Differ</span></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.legalRisk?.differ
                    }}</span>
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor4"></span
                      ><span class="font18 font1A2332"
                        >Not Evaluated</span
                      ></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.legalRisk?.notEvaluated
                    }}</span>
                  </p>
                </div>
                <div class="Risk-Scanning-echarts">
                  <p
                    class="font20 font1A2332 margin-bottom20 margin-top20 font_bold"
                  >
                    Organizational Risk
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor1"></span
                      ><span class="font18 font1A2332">Good</span></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.organizationalRisk?.good
                    }}</span>
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor2"></span
                      ><span class="font18 font1A2332">General</span></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.organizationalRisk?.general
                    }}</span>
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor3"></span
                      ><span class="font18 font1A2332">Differ</span></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.organizationalRisk?.differ
                    }}</span>
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor4"></span
                      ><span class="font18 font1A2332"
                        >Not Evaluated</span
                      ></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.organizationalRisk?.notEvaluated
                    }}</span>
                  </p>
                </div>
                <div class="Risk-Scanning-echarts">
                  <p
                    class="font20 font1A2332 margin-bottom20 margin-top20 font_bold"
                  >
                    Operational Risk
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor1"></span
                      ><span class="font18 font1A2332">Good</span></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.operationalRisk?.good
                    }}</span>
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor2"></span
                      ><span class="font18 font1A2332">General</span></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.operationalRisk?.general
                    }}</span>
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor3"></span
                      ><span class="font18 font1A2332">Differ</span></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.operationalRisk?.differ
                    }}</span>
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor4"></span
                      ><span class="font18 font1A2332"
                        >Not Evaluated</span
                      ></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.operationalRisk?.notEvaluated
                    }}</span>
                  </p>
                </div>
                <div class="Risk-Scanning-echarts">
                  <p
                    class="font20 font1A2332 margin-bottom20 margin-top20 font_bold"
                  >
                    Financial Risk
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor1"></span
                      ><span class="font18 font1A2332">Good</span></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.financialRisk?.good
                    }}</span>
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor2"></span
                      ><span class="font18 font1A2332">General</span></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.financialRisk?.general
                    }}</span>
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor3"></span
                      ><span class="font18 font1A2332">Differ</span></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.financialRisk?.differ
                    }}</span>
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor4"></span
                      ><span class="font18 font1A2332"
                        >Not Evaluated</span
                      ></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.financialRisk?.notEvaluated
                    }}</span>
                  </p>
                </div>
                <div class="Risk-Scanning-echarts">
                  <p
                    class="font20 font1A2332 margin-bottom20 margin-top20 font_bold"
                  >
                    Credit Risk
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor1"></span
                      ><span class="font18 font1A2332">Good</span></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.creditRisk?.good
                    }}</span>
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor2"></span
                      ><span class="font18 font1A2332">General</span></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.creditRisk?.general
                    }}</span>
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor3"></span
                      ><span class="font18 font1A2332">Differ</span></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.creditRisk?.differ
                    }}</span>
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor4"></span
                      ><span class="font18 font1A2332"
                        >Not Evaluated</span
                      ></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.creditRisk?.notEvaluated
                    }}</span>
                  </p>
                </div>
                <div class="Risk-Scanning-echarts">
                  <p
                    class="font20 font1A2332 margin-bottom20 margin-top20 font_bold"
                  >
                    Compliance
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor1"></span
                      ><span class="font18 font1A2332">Good</span></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.complianceRisk?.good
                    }}</span>
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor2"></span
                      ><span class="font18 font1A2332">General</span></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.complianceRisk?.general
                    }}</span>
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor3"></span
                      ><span class="font18 font1A2332">Differ</span></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.complianceRisk?.differ
                    }}</span>
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor4"></span
                      ><span class="font18 font1A2332"
                        >Not Evaluated</span
                      ></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.complianceRisk?.notEvaluated
                    }}</span>
                  </p>
                </div>
                <div class="Risk-Scanning-echarts">
                  <p
                    class="font20 font1A2332 margin-bottom20 margin-top20 font_bold"
                  >
                    Sustainability
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor1"></span
                      ><span class="font18 font1A2332">Good</span></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.sustainabilityRisk?.good
                    }}</span>
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor2"></span
                      ><span class="font18 font1A2332">General</span></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.sustainabilityRisk?.general
                    }}</span>
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor3"></span
                      ><span class="font18 font1A2332">Differ</span></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.sustainabilityRisk?.differ
                    }}</span>
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor4"></span
                      ><span class="font18 font1A2332"
                        >Not Evaluated</span
                      ></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.sustainabilityRisk?.notEvaluated
                    }}</span>
                  </p>
                </div>
                <div class="Risk-Scanning-echarts">
                  <p
                    class="font20 font1A2332 margin-bottom20 margin-top20 font_bold"
                  >
                    Industry Risk
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor1"></span
                      ><span class="font18 font1A2332">Good</span></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.industryRisk?.good
                    }}</span>
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor2"></span
                      ><span class="font18 font1A2332">General</span></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.industryRisk?.general
                    }}</span>
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor3"></span
                      ><span class="font18 font1A2332">Differ</span></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.industryRisk?.differ
                    }}</span>
                  </p>
                  <p class="flex_center_bettwen margin-bottom20">
                    <span
                      ><span class="colorRsik RiskColor4"></span
                      ><span class="font18 font1A2332"
                        >Not Evaluated</span
                      ></span
                    >
                    <span class="font1290C9 font18">{{
                      RiskDataNum?.industryRisk?.notEvaluated
                    }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="CompanyCompany" v-show="Compare">
            <compareCompanys
              :compareList="compareList"
              @CompareShowfalse="CompareShow($event)"
            ></compareCompanys>
          </div>
        </div>
      </div>
      <Suo
        :suoClose="Update"
        @closeCloseDialog="clossuoDialog($event)"
        @closeCloseDialog1="clossuoDialog1($event)"
      >
      </Suo>
      <Deepassment
        :showReport="showReportIndex"
        @closeReportDialog="closeDialog3($event)"
      ></Deepassment>
      <Reporterror
        :showReport="ReportError"
        :companynameen="CompanyName"
        @closeReportDialog="closeDialog($event)"
        :powerStatus="powerToReportErrorStatus"
      ></Reporterror>
      <riskdrawertwo
        :updateDowin="updateDowinList?.length > 0"
        :showReport="reportDialog"
        @closeReportDialog="closeRiskDialog($event)"
      ></riskdrawertwo>
    </div>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import {
  getRiskDataContent,
  riskdata,
  staticRiskData,
} from "@/api/searchApi.js";
import {
  addItems,
  showItems,
  removeItems,
  downloadOnlinePdf,
  getUserConsumptionPage,
} from "@/api/userApi";
import Reporterror from "../company/list/reportError.vue";
import Suo from "./RiskScanUpdate.vue";
import compareCompanys from "../company/list/compareCompanys";
import noDate from "../../components/noDate/index.vue";
import Deepassment from "../../components/deepassment/index.vue";
import tools from "@/views/layout/tools.vue";
import riskdrawertwo from "../../components/risk-drawer/riskdrawertwo.vue";
import { getoptions } from "@/api/companyApi";
export default {
  mixins: [mixins1],
  components: {
    Suo,
    Reporterror,
    noDate,
    compareCompanys,
    Deepassment,
    tools,
    riskdrawertwo,
    // gui_table
  },
  name: "",
  props: {},
  watch: {
    token: {
      handler(newVal, oldVal) {
        if (newVal) {
        } else {
          this.setToolsfalse();
        }
      },
      immediate: true,
    },
    //  Label

    // columns
    "$store.state.app.ColumnsArr": {
      handler(newVal, oldVal) {
        // 在这里处理columns属性的变化
        if (newVal.length > 0) {
          // this.selectedColumns = newVal;
          this.selectedColumns = [
            {
              screenName: "Legal Risk",
              columnName: "companyLegalRiskSignalCode",
            },
            {
              screenName: "Organizational Risk",
              columnName: "companyOrgStructureRiskSignalCode",
            },
            {
              screenName: "Operational Risk",
              columnName: "companyOperatingRiskSignalCode",
            },
            {
              screenName: "Financial Risk",
              columnName: "companyFinancialRiskSignalCode",
            },
            {
              screenName: "Credit Risk",
              columnName: "companyCreditRiskSignalCode",
            },
            {
              screenName: "Compliance ",
              columnName: "complianceRiskSignalCode",
            },
            {
              screenName: "Sustainability ",
              columnName: "companySustainabilityRiskSignalCode",
            },
            {
              screenName: "Industry Risk",
              columnName: "companyIndustryRiskSignalCode",
            },
          ];
        } else {
          this.selectedColumns = [];
        }
        // 这里可以进行一些逻辑处理或者触发其他操作
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    Clearallflase: {
      handler(newVal, oldVal) {
        if (oldVal != undefined) {
          this.clearAllTags();
        }
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    isOpenSlct: {
      handler(newVal, oldVal) {
        this.isOpenSlct = newVal;
        // 在这里处理columns属性的变化
        if (newVal == false) {
          this.handleSelectionChange([]);
          if (this.$refs.treeTable) {
            this.$refs.treeTable.clearSelection();
          }
          this.compareList = [];
          this.$store.dispatch("app/setcollectList", []);
          this.$store.dispatch("app/setchangeList", this.compareList);
        }
        this.refresh++;

        // 这里可以进行一些逻辑处理或者触发其他操作
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    Sort: {
      handler(newVal, oldVal) {
        this.Sort = newVal;
        if (newVal.length > 0) {
          this.page.pageNo = 1;
          this.parentTable = [];
          this.searchCompanyByName();
        }
        // 在这里处理Sort属性的变化
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    Saved: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.parentTable = [];
          this.pageNo = 1;
          this.Saved = newVal;
          this.getCollection();
        }

        // 在这里处理Sort属性的变化
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    Update: {
      handler(newVal, oldVal) {
        this.Update = newVal;
        // 在这里处理columns属性的变化
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    Compare: {
      handler(newVal, oldVal) {
        this.Compare = newVal;
        if (this.Compare) {
          this.setToolsfalse();
        } else {
          this.handleSelectionChange([]);
          this.refresh++;
        }
        // 在这里处理columns属性的变化
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    Export: {
      handler(newVal, oldVal) {
        this.Export = newVal;
        // 在这里处理columns属性的变化
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    ReportError: {
      handler(newVal, oldVal) {
        this.ReportError = newVal;
        this.powerToReportErrorStatus = true;
        // 在这里处理columns属性的变化
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },

    countryList(val) {
      this.cascaderKey++;
    },
    industryList(val) {
      this.cascaderKey++;
    },
  },
  updated() {
    window.addEventListener("setItem", () => {
      this.token = localStorage.getItem("token");
    });
  },
  beforeDestroy() {
    this.$off("closeReportDialog");
    window.removeEventListener("resize", this.handleResize);
  },
  created() {
    this.getPower();
  },
  mounted() {
    this.setThemeColor();
    this.setTools();
    if (this.$route.query.Update) {
      this.getgetUserConsumptionPageList(true);
    } else {
      this.getriskdataList();
      this.getgetUserConsumptionPageList(false);
    }
  },
  computed: {
    filteredColumns() {
      return this.columns.filter((column) => column.visible);
    },
  },

  data() {
    return {
      iconactive2: "table",
      NewsLoading: true,
      UpdateDate: "",
      LegalRisk: "",
      OrganizationalRisk: "",
      ComplianceRisk: "",
      OperationalRisk: "",
      FinancialRisk: "",
      CreditRisk: "",
      Industry: "",
      SustainabilityRisk: "",
      IndustryRisk: "",
      UpdateDateList: [
        {
          label: "Good",
          value: 1,
        },
        {
          label: "General",
          value: 2,
        },
        {
          label: "Poor",
          value: 3,
        },
        {
          label: "Unknown",
          value: 4,
        },
      ],
      reLoginVis: false,
      reportDialog: false,

      isComapanyNameEn: true,
      compareList: [],
      compareListParent: [],
      compareListChildreant: [],
      Remove: false,
      isFadedIn: true,
      loading: true,
      isOpenSlct: false,
      Clearallflase: false,
      showReportIndex: false,
      Compare: false,
      Export: false,
      Download: false,
      Update: false,
      Saved: "",
      Sort: [],
      labelCode: [],
      ReportError: false,
      CompanyName: "",
      powerToReportErrorStatus: false,
      retchildren: false,
      // columns
      columns: [
        "company_name",
        "province_en",
        "city_en",
        "district_en",
        "isic_code",
        "incorporation_year",
        "company_type_code",
        "scale_code",
        "status",
      ],
      pageChild: {
        pageNo: 1,
        pageSize: 50,
        total: 0,
      },
      page: {
        pageNo: 1,
        pageSize: 100,
        total: 0,
      },
      pageNo: 1,
      refresh: 0,
      pageSize: 100,
      ChiladTableloading: false,
      powerResult: { list: [] },
      token: localStorage.getItem("token"),
      optionsProps: {
        label: "name", //名称展示
        value: "value", //值展示
        expandTrigger: "click", //次级菜单的展开方式
      },
      parentTable: [],
      expands: [],
      childTable: [],

      showColumnSelector: false,
      selectedColumns: [],

      checkedCompanyList: [],
      companyList: [],
      companyTblList: [],
      branchflag: "",
      openMenu: ["2", "3", "4", "5", "6", "7", "8", "9", "10"],
      // openMenu: [],
      // geographicalLocation:[],

      province: [],
      city: [],
      keywords: "",
      cascaderKey: 0,
      Leftloadig: false,
      searchName: "",
      isShowTooltip: false,
      checkList: [],
      labelCodeName: "",
      ChidLoding: true,
      treeTableObjct: {
        companyComplianceRiskVO: {
          antiCorruptionAndBribery: "",
          companySanction: "",
          exportControl: "",
          litigations: "",
          negativeNews: "",
          productSanction: "",
          title: "",
        },
        companyCreditRiskVO: {
          title: "Credit Risk",
          creditRating: null,
          creditScore: null,
          pd: null,
          solvencyIndex: null,
          debtCollection: null,
          riskIndex: null,
        },
        companyFinancialRiskVO: {
          title: "Financial Risk",
          revenue: null,
          assests: null,
          currency: null,
          profitOrLoss: null,
          liquidity: null,
          growth: null,
          performance: null,
        },
        companyLegalRiskVO: {
          title: "Legal Risk",
          companyId: null,
          companyTypeCodeDescEn: null,
          registrationDate: null,
          registrationStatus: null,
          listed: null,
          legalStatus: null,
        },
        companyOperatingRiskVO: {
          title: "Operational Risk",
          operatingAddressVefified: null,
          industryCode: null,
          businessActivities: null,
          employees: null,
          managementStatus: null,
          currentOperationsStatus: null,
        },
        companyOrgStructureRiskVO: {
          title: "Organizational Risk",
          shareholders: null,
          shareholdingLayers: null,
          corporateShareholders: null,
          individualShareholders: null,
          relatedCompanies: null,
          organizationalStatus: null,
        },
        companySustainabilityRiskVO: {
          title: "Sustainability Risk",
          ratingESG: null,
          yearsInBusiness: null,
          competitiveness: null,
          marketOutlook: null,
          profitOrLoss: null,
          marketPosition: null,
        },
      },
      DilterTable: [],
      updateDowinList: [],
      RiskDataNum: {},
      // srcviewscompanylistcompanyvueDataEnd
    };
  },

  methods: {
    DownloadRisksan() {
      if (this.updateDowinList.length > 0) {
        this.getriskdata(this.updateDowinList);
        this.staticRiskDataList(this.updateDowinList);
        this.iconactive2 = "table";
      }
    },
    getgetUserConsumptionPageList(value) {
      getUserConsumptionPage({
        page: 1,
        pageSize: 100,
        statusList: [1],
      }).then((res) => {
        if (res.code == 200 && res.data.rows.length > 0) {
          let aadis = res.data.rows.map((item) => item.companyAaaid);

          this.updateDowinList = aadis;
          console.log(this.updateDowinList);

          console.log(this.updateDowinList.length);

          if (value) {
            this.getriskdata(this.updateDowinList);
            this.staticRiskDataList(this.updateDowinList);
          }
        } else {
        }
      });
    },
    onChangeParams(val, key) {
      if (key == "LegalRisk") {
        (this.ComplianceRisk = ""),
          (this.OperationalRisk = ""),
          (this.OrganizationalRisk = "");
        (this.FinancialRisk = ""),
          (this.CreditRisk = ""),
          (this.IndustryRisk = ""),
          (this.SustainabilityRisk = ""),
          (this.parentTable = this.DilterTable.filter((item) =>
            val == null || val === ""
              ? true
              : item.companyLegalRiskSignalCode == val,
          ));
      }
      if (key == "ComplianceRisk") {
        this.LegalRisk = "";
        (this.OperationalRisk = ""), (this.OrganizationalRisk = "");
        (this.FinancialRisk = ""),
          (this.CreditRisk = ""),
          (this.IndustryRisk = ""),
          (this.SustainabilityRisk = ""),
          (this.parentTable = this.DilterTable.filter((item) =>
            val == null || val === ""
              ? true
              : item.complianceRiskSignalCode == val,
          ));
      }
      if (key == "OrganizationalRisk") {
        this.LegalRisk = "";
        (this.OperationalRisk = ""),
          (this.ComplianceRisk = ""),
          (this.FinancialRisk = ""),
          (this.CreditRisk = ""),
          (this.IndustryRisk = ""),
          (this.SustainabilityRisk = ""),
          (this.parentTable = this.DilterTable.filter((item) =>
            val == null || val === ""
              ? true
              : item.companyOrgStructureRiskSignalCode == val,
          ));
      }
      if (key == "OperationalRisk") {
        this.LegalRisk = "";
        (this.ComplianceRisk = ""), (this.OrganizationalRisk = "");
        (this.FinancialRisk = ""),
          (this.CreditRisk = ""),
          (this.IndustryRisk = ""),
          (this.SustainabilityRisk = ""),
          (this.parentTable = this.DilterTable.filter((item) =>
            val == null || val === ""
              ? true
              : item.companyOperatingRiskSignalCode == val,
          ));
      }
      if (key == "FinancialRisk") {
        this.LegalRisk = "";
        (this.ComplianceRisk = ""),
          (this.OperationalRisk = ""),
          (this.CreditRisk = ""),
          (this.OrganizationalRisk = "");
        (this.IndustryRisk = ""),
          (this.SustainabilityRisk = ""),
          (this.parentTable = this.DilterTable.filter((item) =>
            val == null || val === ""
              ? true
              : item.companyFinancialRiskSignalCode == val,
          ));
      }
      if (key == "CreditRisk") {
        this.LegalRisk = "";
        (this.ComplianceRisk = ""),
          (this.OperationalRisk = ""),
          (this.OrganizationalRisk = "");
        (this.FinancialRisk = ""),
          (this.IndustryRisk = ""),
          (this.SustainabilityRisk = ""),
          (this.parentTable = this.DilterTable.filter((item) =>
            val == null || val === ""
              ? true
              : item.companyCreditRiskSignalCode == val,
          ));
      }
      if (key == "SustainabilityRisk") {
        this.LegalRisk = "";
        (this.ComplianceRisk = ""), (this.OrganizationalRisk = "");
        (this.OperationalRisk = ""),
          (this.FinancialRisk = ""),
          (this.CreditRisk = ""),
          (this.IndustryRisk = ""),
          (this.parentTable = this.DilterTable.filter((item) =>
            val == null || val === ""
              ? true
              : item.companySustainabilityRiskSignalCode == val,
          ));
      }
      if (key == "IndustryRisk") {
        this.LegalRisk = "";
        (this.ComplianceRisk = ""),
          (this.OperationalRisk = ""),
          (this.OrganizationalRisk = "");
        (this.FinancialRisk = ""),
          (this.CreditRisk = ""),
          (this.SustainabilityRisk = ""),
          (this.parentTable = this.DilterTable.filter((item) =>
            val == null || val === ""
              ? true
              : item.companyIndustryRiskSignalCode == val,
          ));
      }
    },
    getriskdataList() {
      let aaaIds = [];
      let arr = JSON.parse(sessionStorage.getItem("riskScanList"));

      arr.map((item) => {
        aaaIds.push(item.aaa_id);
      });
      this.getriskdata(aaaIds);
      this.staticRiskDataList(aaaIds);
    },
    getriskdata(aadis) {
      this.NewsLoading = true;
      riskdata({
        aaaIds: aadis,
      }).then((res) => {
        if (res.code == 200) {
          this.NewsLoading = false;
          this.parentTable = res.data;
          this.DilterTable = res.data;
        } else {
          this.NewsLoading = false;
          this.parentTable = [];
        }
      });
    },
    staticRiskDataList(aadis) {
      staticRiskData({
        aaaIds: aadis,
      }).then((res) => {
        if (res.code == 200) {
          this.RiskDataNum = res.data;
        }
      });
    },
    openUrl(pathUrl) {
      if (this.compareListParent.length == 1 && this.iconactive2 == "table") {
        let aaa_id = this.compareListParent[0].aaaId;
        let name_en = this.compareListParent[0].companyNameEn;
        let country_code = this.compareListParent[0].countryCode;
        let routeData = this.$router.resolve({
          path: pathUrl,
          query: {
            aaa_id: aaa_id,
            name_en: name_en,
            country_code: country_code,
          },
        });
        window.open(routeData.href, "_blank");
      }
    },
    closeRiskDialog(value) {
      this.reportDialog = value;
    },
    DownloadOnlinePdfDetail(scope) {
      downloadOnlinePdf(scope.aaaId)
        .then((res) => {
          const binaryData = [];
          binaryData.push(res);
          let pdfUrl = window.URL.createObjectURL(
            new Blob(binaryData, { type: "application/pdf" }),
          );
          window.open(pdfUrl, "_blank");
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    clickMenu(name, data) {
      switch (name) {
        case "menu":
          this.$store.dispatch("app/toggleMenu", !this.$store.state.app.isMenu);
          break;
        case "Sort":
          this.Sort = data;
          break;
        case "Saved":
          this.Saved = data;
          break;
        case "select":
          this.$nextTick(() => {
            if (this.isOpenSlct) {
              this.isOpenSlct = false;
              this.isOpenSlct = false;
            } else {
              this.isOpenSlct = "Select";
              this.isOpenSlct = "Select";
            }
          });
          break;
        case "Compare":
          this.$nextTick(() => {
            if (this.Compare) {
              this.Compare = false;
            } else {
              this.Compare = true;
            }
          });
          break;
        case "Export":
          this.$nextTick(() => {
            if (this.Export) {
              this.Export = false;
            } else {
              this.Export = true;
            }
          });
          break;
        case "Update":
          this.$nextTick(() => {
            if (this.Update) {
              this.Update = false;
            } else {
              this.Update = true;
            }
          });
          break;
        case "Report":
          this.$nextTick(() => {
            if (this.ReportError) {
              this.ReportError = false;
            } else {
              this.ReportError = true;
            }
          });
          break;
        case "riskScanning":
          this.$nextTick(() => {
            if (this.riskScanning) {
              this.riskScanning = false;
            } else {
              this.riskScanning = true;
            }
          });
          break;
        case "creditAssessment":
          this.$nextTick(() => {
            if (this.creditAssessment) {
              this.creditAssessment = false;
            } else {
              this.creditAssessment = true;
            }
          });
          break;
        case "dataAnalysis":
          this.$nextTick(() => {
            if (this.dataAnalysis) {
              this.dataAnalysis = false;
            } else {
              this.dataAnalysis = true;
            }
          });
          break;
        case "customPortfolio":
          this.$nextTick(() => {
            if (this.customPortfolio) {
              this.customPortfolio = false;
            } else {
              this.customPortfolio = true;
            }
          });
          break;
        case "print":
          this.$nextTick(() => {
            if (this.print) {
              this.print = false;
            } else {
              this.print = true;
            }
          });
          break;
        case "Clearall":
          this.$nextTick(() => {
            if (this.Clearallflase) {
              this.Clearallflase = false;
            } else {
              this.Clearallflase = true;
            }
          });

          break;
        case "ReSelectCriteria":
          this.$nextTick(() => {
            if (this.ReSelectCriteria) {
              this.ReSelectCriteria = false;
            } else {
              this.ReSelectCriteria = true;
            }
          });
          break;
        case "edit":
          this.edit = data;
          break;
      }
    },
    // 查询不多数据报告错误
    closeDialog3(value) {
      this.showReportIndex = value;
    },
    // 翻译
    cangeCompanyEn() {
      this.isComapanyNameEn = !this.isComapanyNameEn;
    },

    backonlonad() {
      this.$router.go(0);
    },

    // 获取收藏
    getCollection() {
      showItems({
        collectionId: this.Saved,
        page: this.pageNo,
        size: 100,
      }).then((res) => {
        if (res.code == 200) {
          this.Remove = true;
          this.$store.dispatch("app/setchangeList", []);
          this.$store.dispatch("app/setTools", {
            name: "collect",
            key: "isActive",
            value: false,
          });

          this.$store.dispatch("app/setTools", {
            name: "sort",
            key: "isActive",
            value: false,
          });
          this.$store.dispatch("app/setTools", {
            name: "filter",
            key: "isActive",
            value: false,
          });
          this.$store.dispatch("app/setTools", {
            name: "customPortfolio",
            key: "isActive",
            value: false,
          });
          this.$store.dispatch("app/setTools", {
            name: "print",
            key: "isActive",
            value: false,
          });
          this.$store.dispatch("app/setTools", {
            name: "dataAnalysis",
            key: "isActive",
            value: false,
          });
          this.$store.dispatch("app/setTools", {
            name: "creditAssessment",
            key: "isActive",
            value: false,
          });
          this.$store.dispatch("app/setTools", {
            name: "riskScanning",
            key: "isActive",
            value: false,
          });
          this.loading = false;
          this.page.total = res.data.total;
          let parentTable = [];
          let list = (parentTable = res.data.rows);

          //查找本地图片
          list = list.map((item, index) => {
            let countryImg = this.getCountryImgUrl(item.company_country);
            if (countryImg) {
              let flag = require("../../../static" + countryImg);
              parentTable[index].flag = flag;
              this.refresh++;
            }
          });
          this.parentTable.push(...parentTable);
        } else {
          this.loading = false;
          // this.addPopIndex2=true
          this.parentTable = [];
          if (res.ret == "1002") {
            this.ret = true;
          } else {
            this.ret = false;
          }
          // this.page.total = res.data.total;
        }
      });
    },
    // 收藏
    CollectCheckBook() {
      this.checkList = this.$store.state.app.collectList;
      let collect = [];
      this.$store.state.app.changeList.map((item) => {
        collect.push(item.aaaId);
      });

      // this.$store.state.app.changeLis;
      this.checkList.forEach((item) => {
        addItems({
          collectionId: item,
          items: collect,
        }).then((Res) => {
          if (Res.code == 200) {
            this.$message({
              message: Res.msg,
              center: true,
              type: "success",
            });
          } else {
            this.$message({
              message: Res.msg,
              center: true,
              type: "error",
            });
          }
        });
      });
    },
    // 删除收藏
    CollectDelate() {
      let ids = [];
      this.$store.state.app.changeList.map((item) => {
        ids.push(item.collectId);
      });
      removeItems({ ids }).then((res) => {
        if (res.code == 200) {
          this.pageNo = 1;
          this.parentTable = [];
          this.getCollection();
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });
        } else {
          this.$message({
            message: res.msg,
            center: true,
            type: "error",
          });
        }
      });
    },
    // 公司对比返回
    CompareShow(val) {
      this.Compare = false;
      this.setTools();
    },

    //关闭report弹窗
    closeDialog(value) {
      this.ReportError = value;
    },
    // 关闭锁谈框
    clossuoDialog(value) {
      this.Update = value;
    },

    clossuoDialog1(value) {
      // this.suopower = value;
    },
    // 清楚选中

    // 点击跳转
    setid(row) {
      if (this.token) {
        let newscountry = JSON.parse(localStorage.getItem("countryList"))[0]
          ?.countryList;
        let SACode1 = "";
        newscountry.map((item) => {
          if (item.countryCode == row.countryCode) {
            SACode1 = item.dowjonesCountrycode;
          }
        });
        let routeData = this.$router.resolve({
          // Tradecompany/Trade/
          // /company/details
          path:
            "/index/company/details/" +
            row.aaaId +
            "/background/snapshot?id3a=" +
            // "/tradeMap/map?id3a=" +
            row.aaaId +
            "&companyCountry=" +
            row.countryCode +
            "&SACode1=" +
            SACode1 +
            "&companyName=" +
            row.companyNameEn +
            "&keword=" +
            this.$route.query.keword,
        });

        window.open(routeData.href, "_blank");
      }
    },
    // insertMetho
    getPower() {},
    //
    setToolsfalse() {
      this.$store.dispatch("app/setTools", {
        name: "menu",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "riskScanning",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "creditAssessment",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "dataAnalysis",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "customPortfolio",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "print",
        key: "isActive",
        value: false,
      });
    },

    // 多选
    handleSelectionChange(val) {
      this.compareListParent = val;
      this.cheeckbooksUpdate(val);
    },
    //多选选择国家判断状态
    cheeckbooksUpdate(val) {
      this.compareList = [...this.compareListParent];
      this.compareList.map((item) => {
        item.aaa_id = item.aaaId;
      });
      if (val.length == 1) {
        this.CompanyName = val[0].company_name_en;
      }
      this.$store.dispatch("app/setTools", {
        name: "customPortfolio",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: this.compareList.length > 0,
      });

      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: this.compareList.length > 0,
      });
      // 添加 选中公司
      this.$store.dispatch("app/setchangeList", this.compareList);
    },

    default() {}, // setThemeColor
    setThemeColor() {
      this.$store.dispatch("app/setThemColor", "#1290C9");
      this.$store.dispatch("app/setSearchType", "company");
    }, //
    clickIcon(value) {
      this.iconactive2 = value;
      if (value == "computer") {
        this.handleSelectionChange([]);
        if (this.$refs.treeTable) {
          this.$refs.treeTable.clearSelection();
        }
        this.compareList = [];
        this.$store.dispatch("app/setcollectList", []);
        this.$store.dispatch("app/setchangeList", this.compareList);
        this.compareListParent = [];
      }
      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: value == "table",
      });
    },
    // 工具栏高亮控制
    setTools() {
      this.$store.dispatch("app/setTools", {
        name: "filter",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "menu",
        key: "isActive",
        value: true,
      });

      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: true && this.token,
      });
      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false && this.token,
      });

      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "riskScanning",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "creditAssessment",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "dataAnalysis",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: false,
      });

      //   this.$store.dispatch("app/setTools", "filter",'isActive',false);
    },
    // openDetails
    openDetails() {
      return;

      this.$router.push({
        path: "company/details/111",
      });
    }, // slct_rows
    slct_rows(value) {
      this.rowsSlct = value;
      this.$emit("setRowsSlct", this.rowsSlct);
    }, // selectItem
    selectItem(key, item) {
      if (key == "companyName") {
        this.$router.push({
          path: "/index/company/details/1111/background/snapshot",
        });
      }
    }, // openContentTable
    async openContentTable(id) {
      await this.$nextTick();
    },
    checkedAllCompany(val) {
      this.checkedCompanyList = val ? this.companyList : [];
    },
    //展开当前关闭其他展开表格
    onClickExpansion(row) {
      if (this.expands.indexOf(row.aaaId) < 0) {
        this.expands = [];
        this.expands.push(row.aaaId);
        this.branchflag = row.aaaId;
        this.searchChildCompanyByName();
      } else {
        this.expands = [];
      }
    },
    //搜索子表
    async searchChildCompanyByName() {
      console.log(this.branchflag);
      this.ChidLoding = true;
      getRiskDataContent({
        aaaId: this.branchflag,
      }).then((res) => {
        if (res.code == 200) {
          this.treeTableObjct = res.data;
          this.ChidLoding = false;
        } else {
          this.ChidLoding = false;
        }
      });
    },

    // 判断表格是否有子项，无子项不显示展开按钮
    getRowClass(row, rowIndex) {
      // children 是你子项的数组 key
      // if (row.row.branchNumber == 0) {
      // return "row-expand-cover";
      // }
    },
    zhankai() {
      let hasPower = true;
      if (!hasPower) {
        this.openMenu = [];
      }

      // this.formatCC();
    },

    // 过滤数据
    createFilter(queryString) {
      return (countryList) => {
        return (
          countryList.label.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },

    createFilterInd(queryString) {
      return (industryList) => {
        return (
          industryList.name.toLowerCase().indexOf(queryString.toLowerCase()) >
          -1
        );
      };
    },
    //清除所有标签
    clearAllTags() {
      this.zhankai();
      this.parentTable = this.DilterTable;
      this.LegalRisk = "";
      this.OrganizationalRisk = "";
      this.OperationalRisk = "";
      this.FinancialRisk = "";
      this.CreditRisk = "";
      this.ComplianceRisk = "";
      this.SustainabilityRisk = "";
      this.IndustryRisk = "";
    },
    // srcviewscompanylistcompanyvueMethodEnd
  },
};
</script>
<style scoped>
.uedbd2 {
  height: 100%;
  padding-top: 60px;
}
.company_list /deep/.el-table__body-wrapper {
  height: calc(100vh - 22.5rem) !important;
}

.udb507two {
  width: 100% !important;
}

.u1QPawD {
  display: none;
}

.ufe717 {
  width: 12.214285714285714em;
  font-size: 1em;
  background-color: rgb(255, 255, 255);
}

.ukQ5lVZ {
  margin-left: 0.5em;
}

.u82ef5 {
  display: flex;
  padding-right: 0.5em;
  padding-top: 0.5em;
  padding-left: 0.5em;
  padding-bottom: 0.5em;
}

.u0a5ae {
  flex: auto;
  margin-left: 0.5em;
}

.u4bf20 {
  position: relative;
}

.u04a90 {
  display: flex;
  align-items: flex-start;
  height: 0;
  box-sizing: inherit;
  flex: auto;
  overflow-y: auto;
  margin-top: 0.5em;
}

.u1ec6b2 {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  background-color: rgb(240, 240, 240);
}

.uff2cd {
  margin-left: 3.5714285714285716em;
}

.u5t26i8 .active {
  display: block;
}

.u5t26i8 path {
  display: none;
}

.u82ef5:hover .u0a5ae {
  color: rgb(33, 104, 235);
}

.u82ef5:hover .u5a792 {
  display: block;
}

.table_box /deep/ .el-table thead .company_link > .cell {
  padding-left: 2.857142857142857em !important;
}

.table_box /deep/ .el-table thead .cell {
  border-right: 2px solid #cccccc !important;
  min-height: 25px;
}

.table_box /deep/ .el-table thead .el-table-column--selection .cell {
  border-right: none !important;
}

.tree_table_box /deep/ .el-table thead .company_link > .cell {
  padding-left: 1.4285714285714286em !important;
}

.table_box /deep/ .el-table th.el-table__cell {
  height: 3.5714285714285716rem;
}

.table_box /deep/ .el-table td.el-table__cell {
  height: 4.285714285714286em;
}

.left_menu /deep/ .el-loading-mask {
  background-color: #f5f5f5 !important;
}

.left_menu {
  max-height: 100%;
  overflow-y: auto;
}

.hidemenu {
  display: block;
  width: 0em;
  padding-left: 0em;
  padding-top: 0em;
  padding-bottom: 0em;
  padding-right: 0em;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: hidden;
}

.collapsetitel {
  margin-left: 1.7857142857142858rem;
  font-family: "Arial Bold";
  position: relative;
  width: 100%;
}

.Clear_all {
  position: absolute;
  right: 0px;
  font-size: 16px;
  z-index: 999;
  cursor: pointer;
}

.table_box /deep/ .el-table thead .company_link > .cell {
  padding-left: 1.42857142857143em !important;
}

.table_box /deep/.el-table-column--selection .cell {
  padding-right: 0em !important;
}

.table_box /deep/.el-table .cell {
  padding-left: 0.714285714rem !important;
}

.tree_table_box /deep/.el-table .cell {
  padding-left: 1.142857142857143em !important;
}

/deep/ .el-collapse-item__wrap {
  border-bottom: 0.07142857142857142em solid #cccccc;
}

.uVNPU6M {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-right: 0em;
  padding-right: 0em;
  padding-top: 0em;
  padding-bottom: 0em;
  margin-bottom: 0em;
  margin-top: 0em;
  margin-left: 0em;
}

.RiskColor {
  height: 1.42857143rem;
  width: 1.42857143rem;
  border-radius: 50%;
  display: inline-block;
}

.RiskColor1 {
  background-color: #00c924;
}

.RiskColor2 {
  background-color: #ffc000;
}

.RiskColor3 {
  background-color: #f00000;
}

.RiskColor4,
.RiskColornull {
  background-color: #cccccc;
}

.fontRiskColor1 {
  color: #00c924;
}

.fontRiskColor2 {
  color: #ffc000;
}

.fontRiskColor3 {
  color: #f00000;
}

.fontRiskColor4,
.fontRiskColornull {
  color: #cccccc;
}

.Risk-Scanning-right span {
  width: max-content;
  margin-right: 1.42867143rem;
}

.riskScaning-tree {
  padding: 20px;
  background: #ffffff;
  border-radius: 10px;
  width: 24%;
  margin-bottom: 15px;
}

.tree_table_box {
  padding: 1rem !important;
  padding-bottom: 0px !important;
}

.riskScaning-tree-title {
  text-align: center;
  padding-bottom: 14px;
  border-bottom: 1px solid #ddd;
}

.svgbg {
  background-color: #ffffff;
}

.svgclass {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  height: 3.142857142857143rem;
  border-radius: 1.5714285714285714rem;
}

.ViewMore {
  line-height: 1.8571428571428572rem;
  text-align: left;
  font-style: normal;
  text-decoration-line: underline;
  margin-left: 2.142857142857143rem;
}

.contclass {
  font-size: 1.4285714285714286rem;
  color: #1290c9;
  font-style: normal;
  height: 3.5714285714285716rem;
  background: #f5f5f5;
  border-radius: 1.7857142857142858rem;
  display: flex;
  align-items: center;
  padding: 0.21428571428571427rem;
}

.icon {
  margin: 0 1.4285714285714286rem;
}

.Risk-Scanning-echarts {
  padding: 0px 30px;
  width: 24%;
  background-image: url("../../assets//images/RiskScanBg.png");
  /* background-size:100%; */
  background-position: center;
  background-repeat: no-repeat;
  margin-bottom: 20px;
}

.colorRsik {
  height: 12px;
  width: 12px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 10px;
}

.search-select-con {
  width: 100%;
}
/* 测试用：隐藏固定区内的 expand（不会破坏主区） */

.tree_table_box {
  position: relative;
  z-index: 99;
}
.risk_menu_left {
}
@media screen and (max-width: 1920px) {
  .Clear_all {
    font-size: 14px;
  }
  .collapsetitel {
    font-size: 16px;
  }
}
@media screen and (max-width: 1439px) {
  .Clear_all {
    font-size: 12px;
  }
}
</style>
